// Dependencies
import { all, call, takeEvery, fork, put } from "@redux-saga/core/effects";

// Action Types
import {
    EDIT_ALERT_TYPE_SUPPORTED_UPDATE_ALERT_TYPES_REQUEST,
} from 'Redux/actionTypes';

// Actions
import {
    editAlertTypeSupportedUpdateAlertTypesResult,
} from 'Redux/actions';

// Helpers
import { clientMutation, clientQuery } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';

function* updateDeviceModel({ payload }) {
    try {
        let QUERY = `
            mutation updateDeviceModel ($id: String!, $alertTypeIds: [Int]) {
                result: updateDeviceModel (id: $id, alertTypeIds: $alertTypeIds) {
                    id
                    deviceModelAlertTypes {
                        id
                        alertTypeId
                        alertType {
                            id
                            name
                            code
                            parentId
                        }
                    }
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );
        if (data?.result) yield put(editAlertTypeSupportedUpdateAlertTypesResult(data?.result))
        else yield put(editAlertTypeSupportedUpdateAlertTypesResult({ error: true }))

    } catch (exc) {
        yield put(editAlertTypeSupportedUpdateAlertTypesResult({ error: true }))
        ExceptionManager(
            exc,
            "Modules/manufacturers/.components/deviceModelsTab/.components/createEditDeviceModel/.components/editAlertTypeSupported/redux/saga",
            "updateDeviceModel"
        )
    }
}

function* watchMethods() {
    yield takeEvery(EDIT_ALERT_TYPE_SUPPORTED_UPDATE_ALERT_TYPES_REQUEST, updateDeviceModel);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}